<template>
    <core-basic-drop-down
        style="height: 34px"
        v-if="languages.length"
        :items="languages"
        :selection.sync="selected"
        forceFirstOption
        noneLabel="Taal"
    ></core-basic-drop-down>
</template>

<script>
export default {
  data () {
    return {
      languages: this.$store.getters.languages,
      selected: this.selectedValue
    }
  },
  props: {
    selectedValue: {
      default: null,
      type: String | Number,
      required: false
    }
  },
  watch: {
    selected (val) {
      this.$emit('update:selectedValue', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/Language.vue